import React from 'react';
import '../styles/Contact.css';
import { MapPin, Phone, Camera as Instagram } from 'lucide-react';
import { motion } from 'framer-motion';

function Contact() {
  return (
    <div className="contact-info" id="contact">
      <motion.div 
        className="contact-item glass-card"
        whileHover={{ y: -5, boxShadow: "0 10px 30px rgba(214, 135, 179, 0.15)" }}
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
      >
        <div className="icon-wrapper">
          <MapPin className="contact-icon" size={32} />
        </div>
        <h3>Dirección</h3>
        <p>Calle Martín Muñoz de las Posadas, 1C Local</p>
        <p>Vallecas, Madrid</p>
      </motion.div>
      <motion.div 
        className="contact-item glass-card"
        whileHover={{ y: -5, boxShadow: "0 10px 30px rgba(214, 135, 179, 0.15)" }}
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ delay: 0.1 }}
      >
        <div className="icon-wrapper">
          <Phone className="contact-icon" size={32} />
        </div>
        <h3>Teléfono</h3>
        <p><a href="tel:+34633030758">633 030 758</a></p>
      </motion.div>
      <motion.div 
        className="contact-item glass-card"
        whileHover={{ y: -5, boxShadow: "0 10px 30px rgba(214, 135, 179, 0.15)" }}
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ delay: 0.2 }}
      >
        <div className="icon-wrapper">
          <Instagram className="contact-icon" size={32} />
        </div>
        <h3>Instagram</h3>
        <p><a href="https://www.instagram.com/ari_lashes_beauty" target="_blank" rel="noopener noreferrer">@ari_lashes_beauty</a></p>
      </motion.div>
    </div>
  );
}

export default Contact;